import request from "@/utils/request";
import { path } from "./common";

let path2 = "/p-api/v1";
if (process.env.VUE_APP_MODE === "development") {
  //开发环境下的执行操作
} else if (process.env.VUE_APP_MODE === "production") {
  //生产环境下的执行操作
  // path2 = "/p-api/v1";
}
//登录
export function login(data) {
  return request({
    url: '/fss-auth' + path2 + '/admin/login',
    // url: "/fss-auth/p-api/v1/admin/loginM2",
    method: "post",
    data
  });
}
//获取当前用户的平台权限列表
export function getPlatformList() {
  return request({
    url: path + "/sys-user/get-platform-list",
    method: "get"
  });
}
//登出
export function logout() {
  return request({
    url: "/vue-admin-template/user/logout",
    method: "post"
  });
}

//获取验证码
export function getVerifyCode() {
  return request({
    url: "/fss-auth/p-api/v1/verify-code/data",
    method: "get"
  });
}
/**
 * 修改当前登录账号密码
 */
export function changePsd(data) {
  return request({
    url: "/fss-auth" + path2 + "/admin/change-password",
    method: "post",
    data
  });
}

/**
 * 获取当前用户信息
 * @param {Object} params
 * @returns
 */
export function getCurrentUserInfo(params) {
  return request({
    url: "/ms.api.yunsoho.cn/fss-auth/p-api/v1/sys-user/get-current-user-info",
    params
  });
}
